import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import qs from 'qs'
import queryString from 'query-string'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Tuning2OutlineIcon } from '../../../components/AppIcon'
import EmptyContent from '../../../components/EmptyContent'
import {
  DATE_FORMAT_LIST,
  ELECTRONIC_DOCUMENT_STATUS,
  ISO_DATE_FORMAT,
} from '../../../constants'
import { checkValidFormFieldValue } from '../../../utils/helper'

const { RangePicker } = DatePicker
const { Option } = Select

const InternalDocumentSignDocAdvanceFilterV2 = props => {
  const [showFilter, setShowFilter] = useState(false)

  const { electronicDocumentStore } = props

  const location = useLocation()
  const history = useHistory()
  const queryStringParse = useMemo(
    () => qs.parse(location.search.replace('?', '')),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse.title)) count++
    if (queryStringParse.status) count++
    if (queryStringParse.from_date && queryStringParse.to_date) count++

    return count
  }, [queryStringParse])

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        title: queryStringParse.title || undefined,
        status: queryStringParse.status || undefined,
        submit_date:
          queryStringParse.from_date && queryStringParse.to_date
            ? [
                moment(queryStringParse.from_date),
                moment(queryStringParse.to_date),
              ]
            : undefined,
      })
    }
  }, [queryStringParse, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      title: values.title ? values.title.trim() : null,
      status: values.status || null,
      from_date: values.submit_date
        ? moment(values.submit_date[0]).format(ISO_DATE_FORMAT)
        : null,
      to_date: values.submit_date
        ? moment(values.submit_date[1]).format(ISO_DATE_FORMAT)
        : null,
    }

    electronicDocumentStore.setQueryParamsSignDocument({
      ...params,
      page: 0,
      size: 10,
    })

    const queryStringStringify = queryString.stringify(
      {
        ...params,
        page: 0,
        size: 10,
      },
      {
        skipNull: true,
      }
    )

    history.replace(`/internal-document/sign-document?${queryStringStringify}`)

    onToggleFilter()
  }

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Tiêu đề"
                name="title"
                style={{ marginBottom: 16 }}>
                <Input placeholder="Nhập tiêu đề" allowClear className="h-40" />
              </Form.Item>
              <Form.Item
                label="Trạng thái"
                name="status"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  allowClear
                  className="h-40"
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent={<EmptyContent />}
                  optionFilterProp={'name'}
                  placeholder={'Chọn trạng thái'}>
                  <Option
                    key={ELECTRONIC_DOCUMENT_STATUS.PENDING}
                    value={ELECTRONIC_DOCUMENT_STATUS.PENDING}
                    name={ELECTRONIC_DOCUMENT_STATUS.PENDING}>
                    Chưa xử lý
                  </Option>
                  <Option
                    key={ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL}
                    value={ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL}
                    name={ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL}>
                    Văn thư duyệt
                  </Option>
                  <Option
                    key={ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL}
                    value={ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL}
                    name={ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL}>
                    Lãnh đạo duyệt
                  </Option>
                  <Option
                    key={ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER}
                    value={ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER}
                    name={ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER}>
                    Cấp số
                  </Option>
                  <Option
                    key={ELECTRONIC_DOCUMENT_STATUS.RELEASE}
                    value={ELECTRONIC_DOCUMENT_STATUS.RELEASE}
                    name={ELECTRONIC_DOCUMENT_STATUS.RELEASE}>
                    Phát hành
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Ngày trình"
                name="submit_date"
                style={{ marginBottom: 16 }}>
                <RangePicker
                  placeholder={['Ngày trình: Từ ngày', 'Đến ngày']}
                  format={DATE_FORMAT_LIST}
                  style={{ width: '100%' }}
                  className="h-40"
                />
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()

                  electronicDocumentStore.setQueryParamsSignDocument({
                    page: 0,
                    size: 10,
                  })

                  history.replace(`/internal-document/sign-document`)
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

InternalDocumentSignDocAdvanceFilterV2.propTypes = {}

export default inject('electronicDocumentStore')(
  observer(InternalDocumentSignDocAdvanceFilterV2)
)
